<template>
  <v-app id="login">
    <v-container fluid fill-height class="pa-0">
      <v-layout row wrap>
        <v-flex sm6 md8 lg8>
          <div id="divider" v-bind:style="this.backgroundImage"></div>
        </v-flex>
        <v-flex
          xs12
          sm6
          md4
          lg4
          style="display: flex; align-items: center; flex-direction: column"
          :style="
            $vuetify.theme.dark
              ? 'background-color: #121212 !important'
              : 'background-color: #ffffff'
          "
        >
          <login-form redirect="true" class="pa-3" />
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import LoginForm from "../../components/widgets/form/LoginForm";
import "font-awesome/css/font-awesome.css";

export default {
  components: { LoginForm },
  metaInfo: {
    title: "LS",
    titleTemplate: "%s - Entrar",
    htmlAttrs: {
      lang: "pt-br",
      amp: false,
    },
  },
  data: () => ({
    logging: false,
    model: {
      email: "",
      password: "",
    },
    backgrounds: [
      'background-image: url("/img/login/tubarao-01.jpg")',
      'background-image: url("/img/login/tubarao-02.jpg")',
      'background-image: url("/img/login/tubarao-03.jpg")',
      'background-image: url("/img/login/tubarao-04.gif")',
      'background-image: url("/img/login/tubarao-05.gif")',
      'background-image: url("/img/login/tubarao-06.gif")',
      // 'background-image: url("/img/login/tubarao-07.gif")',
      'background-image: url("/img/login/tubarao-08.gif")',
      'background-image: url("/img/login/tubarao-09.gif")',
      'background-image: url("/img/login/tubarao-10.jpg")',
    ],
    backgroundImage: 'background-image: url("/img/login/tubarao-01.jpg")',
  }),
  methods: {},
  mounted() {
    const index = Math.floor(Math.random() * 9);
    this.backgroundImage = this.backgrounds[index];
  },
};
</script>
<style scoped lang="scss">
#login {
  height: 0%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}

#divider {
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
  background-size: cover;
  overflow: hidden;
}
</style>
